import { Component, OnInit } from '@angular/core';
import { RequestService } from '../../requets/shared/request.service';
import { Testing } from '../../requets/shared/model/testing.model';
import { FilterRequestTest } from '../shared/filter-request-test.model';
import { UserService } from '../../requets/shared/user.service';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { Role } from '../../requets/shared/model/Role.model';
import { ReportsService } from '../shared/reports.service';
import { RequestTest } from '../shared/request-test.model';


@Component({
  selector: 'app-view-test',
  templateUrl: './view-test.component.html',
  styleUrls: ['./view-test.component.scss']
})
export class ViewTestComponent implements OnInit {
  enabledSpinner = false;
  testing: Testing[];
  currentRol: Role;
  roles: Role[];
  tests: RequestTest[];

  constructor(private reportService: ReportsService, private requestService: RequestService,
     private utilityService: UtilityService, private userService: UserService) { }

  ngOnInit() {
    this.getTestings();
  }

  private getTestings() {
    this.enabledSpinner = true;
    this.requestService.getTestings().subscribe(result => {
     this.enabledSpinner = false;
      if (result.data !== {}) {
        this.testing = result.data as Testing[];
        this.getUserInfor();
      }
    });
  }

  searchField(field: FilterRequestTest) {
      field.rol =  this.currentRol.rol;
      this.enabledSpinner = true;
      field.cedula =  localStorage.getItem('cedula');
      this.reportService.getTestRequest(field).subscribe(
        (result) => {
          this.enabledSpinner = false;
          if (result.data) {
           this.tests = result.data as RequestTest[];
          }
        }
      );
  }

  generateExcel() {
  this.utilityService.generateExcel(this.tests, 'ReportePruebas');
}

  private getUserInfor() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.enabledSpinner = true;
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        this.enabledSpinner = false;
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 2);
            this.currentRol = roleInformation.currentRol;
        }
      }
    );
  }

}
